// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Global Layout Components
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";

// Pages
import Homepage from "./Homepage";
import Productpage from "./components/Products/Productpage";
import Aboutus from "./components/About/Aboutus";
import Contactus from "./components/Contact/Contactus";
import Investor from "./components/Investor/Investor"

// Product Detail Pages
import MedicalWear from "./components/Productdetailpage/Medicalwear";
import HipUDrape from "./components/Productdetailpage/HipUDrape"
import KneeODrape from "./components/Productdetailpage/KneeODrape";
import ArthroscopyDrape from "./components/Productdetailpage/ArthroscopyDrape";
import GynaeDrape from "./components/Productdetailpage/GynaeDrape"
import GeneralOTDrape from "./components/Productdetailpage/GeneralOTDrape"
import SagittalBlade from "./components/Productdetailpage/SagittalBlade";
import OrthopedicSuctionTube from "./components/Productdetailpage/OrthopedicSuctionTube";
import ArthroscopyShaverBlades from "./components/Productdetailpage/ArthroscopyShaverBlades";
import ProductCategoryPage from "./components/ProductCategories/ProductCategoryPage";

// Add more detail components as needed

const App = () => {
  return (
    <Router basename="/">
      <Header />

      <Routes>
        {/* Main Pages */}
        <Route path="/" element={<Homepage />} />
        <Route path="/products" element={<Productpage />} />
        <Route path="/investor" element={<Investor />} />
        <Route path="/about" element={<Aboutus />} />
        <Route path="/contact" element={<Contactus />} />
        <Route path="/products/:categorySlug" element={<ProductCategoryPage />} />


        {/* Product Detail Pages */}
        <Route path="/Hip-u-drape" element={<HipUDrape />} />
        <Route path="/surgical-gown" element={<MedicalWear />} />
        <Route path="/knee-o-drape" element={<KneeODrape />} />
        <Route path="/Arthroscopy-drape" element={<ArthroscopyDrape />} />
        <Route path="/gynae-drape" element={<GynaeDrape />} />
        <Route path="/general-ot-drape" element={<GeneralOTDrape />} />
        <Route path="/sagittal-blade" element={<SagittalBlade />} />
        <Route path="/orthopedic-suction-tube" element={<OrthopedicSuctionTube />} />
        <Route path="/arthroscopy-shaver-blades" element={<ArthroscopyShaverBlades />} />

        {/* Add more detail routes like <Route path="/ortho-implants" ...> */}
      </Routes>

      <Footer />
    </Router>
  );
};

export default App;
